import React from 'react';
const FirebaseContext = React.createContext<any | null>(null);
const AuthUserContext = React.createContext<any | null>(null);
export default FirebaseContext
export { AuthUserContext }